import { render, staticRenderFns } from "./UpdateBonusLists.vue?vue&type=template&id=364bd325&"
import script from "./UpdateBonusLists.vue?vue&type=script&lang=js&"
export * from "./UpdateBonusLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports